function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "checkIconTitle"
}, "Check");

var _ref3 = /*#__PURE__*/React.createElement("desc", {
  id: "checkIconDesc"
}, "Check icon");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M32.75 65.5C14.663 65.5 0 50.837 0 32.75S14.663 0 32.75 0 65.5 14.663 65.5 32.75 50.837 65.5 32.75 65.5zm-5.01-15.52c1.12 0 2.23-.43 3.08-1.28l24-24a4.37 4.37 0 0 0 0-6.17 4.37 4.37 0 0 0-6.17 0L27.74 39.44l-7.82-7.82a4.37 4.37 0 0 0-6.17 0 4.37 4.37 0 0 0 0 6.17L24.66 48.7c.85.85 1.96 1.28 3.08 1.28z",
  fillRule: "nonzero"
});

var SvgCheck = function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 66 66",
    fill: "currentColor",
    "aria-labelledby": "checkIconTitle checkIconDesc",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "checkIconTitle"
  }, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check.a31043f2.svg";
export { ForwardRef as ReactComponent };